import { LogIn04Icon, LogOut04Icon, UploadCloud01Icon, DownloadCloud01Icon } from '@metarouter-private/mr-mui';

import { DRAWER_TABS } from 'app/event-monitoring/event-debugger/event-debugger-table/DebuggerDrawer';

const EVENT_BUTTONS = [
  {
    title: 'Input Event',
    Icon: LogIn04Icon,
    dataTestId: 'inputEventDrawerTrigger',
    disabledKey: 'inputEvent',
    eventTab: DRAWER_TABS.INPUT,
  },
  {
    title: 'Output Event',
    Icon: LogOut04Icon,
    dataTestId: 'outputEventDrawerTrigger',
    disabledKey: 'outputEvent',
    eventTab: DRAWER_TABS.OUTPUT,
  },
  {
    title: 'Request',
    Icon: UploadCloud01Icon,
    dataTestId: 'requestDrawerTrigger',
    disabledKey: 'requestHeaders',
    eventTab: DRAWER_TABS.REQUEST,
  },
  {
    title: 'Response',
    Icon: DownloadCloud01Icon,
    dataTestId: 'responseDrawerTrigger',
    disabledKey: 'response',
    eventTab: DRAWER_TABS.RESPONSE,
  },
];

export default EVENT_BUTTONS;
